import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { ChartConfiguration } from '@common-modules/shared/charts/model/chart/chart-configuration';
import { DataVisualizationChartConfigPopupDimensions } from '@common-modules/shared/constants/dimensions.constants';
import { DialogService } from '@common-modules/shared/dialogs/dialogs.service';
import { LocalizationHelperService } from '@common-modules/shared/localization/localization-helper.service';
import { LogService } from '@common-modules/shared/wlm-log/log.service';
import { BaseCustomizableChartComponent } from '@common-modules/wlm-charts/core/base-chart/base-customizable-chart.component';
import { CustomizableChartComponent } from '@common-modules/wlm-charts/core/customizable-chart/customizable-chart.component';
import { plainToClass } from 'class-transformer';

const COMPONENT_SELECTOR = 'ct-customizable-chart';

@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './ct-customizable-chart.component.html',
  styleUrl: './ct-customizable-chart.component.scss',
  standalone: false,
})
export class CTCustomizableChartComponent extends BaseCustomizableChartComponent implements OnInit {
  @ViewChild(CustomizableChartComponent) customizableChart: CustomizableChartComponent;
  // T_SCOPE = `${AppModules.DataVisualization}.${COMPONENT_SELECTOR}`;
  // T_SCOPE_CHART_BUTTONS = `${AppModules.WlmCharts}.buttons`;

  constructor(
    private _dialogService: DialogService,
    _localization: LocalizationHelperService,
    _logService: LogService,
  ) {
    super(_localization, _logService);
  }

  ngOnInit(): void { }

  onChartConfiguration() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      chartConfiguration: this.chartConfiguration,
    };
    dialogConfig.height = DataVisualizationChartConfigPopupDimensions.Height;
    dialogConfig.width = DataVisualizationChartConfigPopupDimensions.Width;

    const popupRef = null; /* this._dialogService.openComponent(
      DataVisualizationChartConfigPopupComponent,
      dialogConfig
    );*/

    popupRef?.afterClosed().subscribe((result: ChartConfiguration) => {
      if (!result) {
        return;
      }

      const chartConfiguration = plainToClass(ChartConfiguration, result);
      this.chartConfiguration = chartConfiguration;
    });
  }

  debugName(): string {
    return COMPONENT_SELECTOR;
  }

  public setDateParams(startDate: Date, endDate: Date) {
    this.customizableChart.setDateParams(startDate, endDate);
  }
}
